import { render, staticRenderFns } from "./TalkrecordList.vue?vue&type=template&id=cda2ed40&scoped=true"
import script from "./TalkrecordList.vue?vue&type=script&lang=js"
export * from "./TalkrecordList.vue?vue&type=script&lang=js"
import style0 from "./TalkrecordList.vue?vue&type=style&index=0&id=cda2ed40&prod&lang=css"
import style1 from "./TalkrecordList.vue?vue&type=style&index=1&id=cda2ed40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda2ed40",
  null
  
)

export default component.exports